import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewbox="0 0 12 12" fill="none"><rect width="12" height="12" fill="#F59511" rx="3"></rect><path fill="#0E1015" d="M7.976 6.476c-.368-.225-.252-.068-.097.081.658.621 1.093 1.231 1.255 1.76.105.344.01.553-.146.252-.24-.457-.555-.808-.748-.963-.19-.153-.186-.08-.094.042.375.502.597 1.006.375 1.398-.366.641-1.84.48-3.29-.36-1.845-1.067-2.983-2.527-2.565-3.274.181-.327.675-.462 1.259-.412.123.011.116-.03.006-.059-.695-.184-1.517-.011-1.809.498-.531.924.707 2.644 2.77 3.839a9.278 9.278 0 0 0 1.68.76c.41.138.351.302-.351.165-.746-.144-1.675-.534-2.552-1.051-.254-.149-.287-.09-.099.094.175.171.505.432.907.67 2.047 1.223 4.603 1.542 5.337.266.655-1.14-.523-2.903-1.838-3.706Z"></path><path fill="#0E1015" d="m1.5 2 1.1 2H5v3.78c-.033-.025.03.025 0 0 .554.422 1.388.843 2 .92-.031-.003.033.003 0 0V4h2.4l1.1-2h-9Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
